'use client'

import { useLocale } from 'next-intl'
import { useMemo } from 'react'

export function CookieBanner() {
    const locale = useLocale()

    const language = useMemo(() => {
        if (locale.includes('-')) {
            return locale.split('-')[0].toLowerCase()
        }

        return locale.toLowerCase()
    }, [locale])

    const config = useMemo(
        () => `var _iub = _iub || [];
                // GTM is deferred until Marketing consent, so dataLayer may not exist yet when the
                // callback below fires. Ensure it does; GTM flushes the queue once it loads.
                window.dataLayer = window.dataLayer || [];
                _iub.csConfiguration = {
                    "invalidateConsentWithoutLog":true,
                    "consentOnContinuedBrowsing":false,
                    "perPurposeConsent":true,
                    "lang":"${language}",
                    "siteId":2503784,
                    "floatingPreferencesButtonDisplay":false,
                    "cookiePolicyId":77106105,
                    "banner": {
                        "closeButtonDisplay":false,
                        "acceptButtonDisplay":true,
                        "customizeButtonDisplay":true,
                        "acceptButtonColor":"#53f293",
                        "acceptButtonCaptionColor":"#1c1d28",
                        "customizeButtonColor":"rgba(219, 219, 219, 0.10196078431372549)",
                        "customizeButtonCaptionColor":"white",
                        "rejectButtonDisplay":true,
                        "rejectButtonColor":"#1c1d28",
                        "rejectButtonCaptionColor":"white",
                        "listPurposes":true,
                        "explicitWithdrawal":true,
                        "position":"bottom",
                        "backgroundOverlay":true,
                        "textColor":"white",
                        "backgroundColor":"#1c1d28"
                    },
                    "callback": {
                        onPreferenceExpressedOrNotNeeded: function (preference) {
                          // Notify our React consent store (usePurposeConsent) so gates re-read live.
                          if (window.__onConsentChange) { window.__onConsentChange(); }
                          dataLayer.push({
                            iubenda_ccpa_opted_out: _iub.cs.api.isCcpaOptedOut(),
                          });
                          // preferences parameter may be undefined if both GDPR and LGPD do not apply
                          // we may need the line below to find USPR preferences instead of relying
                          // on preferences parameter
                          var otherPreferences = _iub.cs.api.getPreferences();
                          if (otherPreferences) {
                            var usprPreferences = otherPreferences.uspr;
                            if (usprPreferences) {
                              for (var purposeName in usprPreferences) {
                                if (usprPreferences[purposeName]) {
                                  dataLayer.push({
                                    event: 'iubenda_consent_given_purpose_' + purposeName,
                                  });
                                }
                              }
                            }
                          }
                          if (!preference) {
                            dataLayer.push({
                              event: 'iubenda_preference_not_needed',
                            });
                          }
                          else if (preference.consent === true) {
                            dataLayer.push({
                              event: 'iubenda_consent_given',
                            });
                          }
                          else if (preference.consent === false) {
                            dataLayer.push({
                              event: 'iubenda_consent_rejected',
                            });
                          }
                          else if (preference.purposes) {
                            for (var purposeId in preference.purposes) {
                              if (preference.purposes[purposeId]) {
                                dataLayer.push({
                                  event: 'iubenda_consent_given_purpose_' + purposeId,
                                });
                              }
                            }
                          }
                        }		
                    }
                };`,
        [language]
    )

    const script = `<script type="text/javascript">${config}</script>
                <script type="text/javascript" src="//cs.iubenda.com/sync/2503784.js"></script>
                <script type="text/javascript" src="//cdn.iubenda.com/cs/iubenda_cs.js" charset="UTF-8" async></script>`

    return <div id="cookie-banner" dangerouslySetInnerHTML={{ __html: script }} />
}
